import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SetDialpadIntegrationIsEnabled as SetDialpadIntegrationIsEnabledMutation,
    SetDialpadIntegrationIsEnabledVariables,
} from 'nutshell-graphql-types';

import SET_DIALPAD_INTEGRATION_IS_ENABLED from '../mutations/set-dialpad-integration-is-enabled.graphql';

export const useSetDialpadIntegrationIsEnabled = (): {
    setDialpadIntegrationIsEnabled: (arg1: boolean) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [setDialpadIntegrationIsEnabled, {loading, error}] = useMutation<
        SetDialpadIntegrationIsEnabledMutation,
        SetDialpadIntegrationIsEnabledVariables
    >(SET_DIALPAD_INTEGRATION_IS_ENABLED);

    return {
        setDialpadIntegrationIsEnabled: (isEnabled: boolean) =>
            setDialpadIntegrationIsEnabled({variables: {isEnabled}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
